import lodashIsEqual from 'lodash/isEqual';

/**
 * Call this function to compare if two values are equal.
 * @param {T1} a
 * @param {T2} b
 *
 * @return {boolean}
 */
export const isEqual = <T1, T2>(a: T1, b: T2) => lodashIsEqual(a, b);
